import axios from "axios";
import { APICLIENT } from "../shared/index";
import { apiendpoints } from "../constants/api-endpoints";

// ********GET_ALL_NOTIFICATION ***********
export const getNotification = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.GET_NOTIFICATIONS,
      data
    );
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ********GET_ALL_NOTIFICATION_DETAILS ***********
export const getNotificationDetails = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.GET_NOTIFICATIONS_DETAILS,
      data
    );
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ******** READ_NOTIFICATION ***********
export const getReadNotification = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.READ_NOTIFICATIONS,
      data
    );
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ******** DELETE_NOTIFICATION ***********
export const DeleteNotification = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      `${apiendpoints.DELETE_NOTIFICATION}`,
      { id } // Send as JSON body
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

